import React from 'react';
import { useTranslation } from 'react-i18next';

import NotificationItem from './NotificationItem';

const NotificationList = ({ notifications }) => {
  const { t } = useTranslation();

  return (
    <>
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          text={t('text_receive_request_certificate')}
          notification={notification}
        />
      ))}
    </>
  );
};

export default NotificationList;
